import type { IconProps } from "@/types/icon";

const TargetIcon24 = ({
    width = 24,
    height = 24,
    fill = "#F2F2F2",
    ...remainingProps
}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        {...remainingProps}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.8438 4.48593C16.3313 4.87993 19.1213 7.66041 19.515 11.1501H21V12.8386H19.515C19.1213 16.3396 16.3313 19.1201 12.8438 19.5141V21H11.1562V19.5141C7.6575 19.1201 4.87875 16.3396 4.485 12.8386H3V11.1501H4.485C4.87875 7.66041 7.6575 4.87993 11.1562 4.48593V3H12.8438V4.48593ZM6.06 11.9944C6.06 15.2814 8.72625 17.9493 12 17.9493C15.2738 17.9493 17.94 15.2702 17.94 11.9944C17.94 8.71857 15.2738 6.05066 12 6.05066C8.72625 6.05066 6.06 8.70732 6.06 11.9944ZM14.5312 11.9944C14.5312 13.3932 13.398 14.5272 12 14.5272C10.602 14.5272 9.46875 13.3932 9.46875 11.9944C9.46875 10.5955 10.602 9.46155 12 9.46155C13.398 9.46155 14.5312 10.5955 14.5312 11.9944Z"
            fill={fill}
        />
    </svg>
);

export default TargetIcon24;
